export default __webpack_public_path__ + "static/media/396.31b5df7a.jpg";